import { toFlattenedObject } from "@validereinc/utilities";

/**
 * Determines whether a lookup field's filter object is complete enough to
 * enable a data fetch. Filters that reference another form question's answer
 * (resolved via `%questionId%` interpolation in `LookupField`) will have
 * `undefined` values until the user answers that question. All other falsy
 * values (`false`, `0`, `null`, `""`) are legitimate filter operands and must
 * not block the query.
 */
export const isLookupFilterValid = (
  filter: Record<string, unknown> | undefined
): boolean => {
  if (!filter) {
    return true;
  }

  return Object.values(
    toFlattenedObject(filter, { ignoreUndefined: false })
  ).every((value) => value !== undefined);
};
